import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import BrokerAnalytics from "./broker/BrokerAnalytics";
import BrokerInvoicing from "./broker/BrokerInvoice";
import CarrierNetwork from "./broker/CarrierManagement/CarrierManagement";
import CarrierManagement from "./broker/CarrierManagement/CarrierManagement";
import { ReceiverView } from "./receiver/ReceiverView";
import ClaimsView from "./pages/claims/ClaimsPage";
import ReceiverInvoicing from "./receiver/ReceiverInvoicing";
import { OrgType, useAuthService } from "./auth/AuthProvider";
import { PageNotFound } from "./components/PageNotFound";
import { LoadsPage } from "./pages/loads/LoadsPage";
import {VendorView} from './shipper/VendorView'

type Props = {};

export const PrivateRoutes: React.FC<Props> = () => {
  const { authState } = useAuthService();
  const orgType = authState?.orgType;
  console.log("orgType:", orgType);

  if (!orgType) return null;
  return (
    <Routes>
      <Route path="/" element={<Navigate to={defaultPath(orgType)} />} />

      {orgType === "Broker" && (
        <>
          <Route path="/broker" element={<LoadsPage />} />
          <Route path="/broker/analytics" element={<BrokerAnalytics />} />
          <Route path="/broker/claims" element={<ClaimsView />} />
          <Route path="/broker/invoicing" element={<BrokerInvoicing />} />
          <Route
            path="/broker/carrier-network/:carrierId"
            element={<CarrierNetwork />}
          />
          <Route path="/broker/carriers" element={<CarrierManagement />} />
        </>
      )}

      {orgType === "Shipper" && (
        <>
          <Route path="/shipper" element={<LoadsPage />} />
        </>
      )}

      {orgType === "Receiver" && (
        <>
          <Route path="/receiver" element={<ReceiverView />} />
          <Route path="/receiver/loads" element={<LoadsPage />} />
          <Route path="/receiver/claims" element={<ClaimsView />} />
          <Route path="/receiver/invoicing" element={<ReceiverInvoicing />} />
        </>
      )}

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

const defaultPath = (orgType: OrgType) => {
  switch (orgType) {
    case "Broker":
      return "/broker";
    case "Shipper":
      return "/shipper";
    case "Receiver":
      return "/receiver";
  }
};
